import React from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';
import MainPage from 'pages/main/MainPage';
// import SampleMainPage from 'pages/sample/SampleMainPage';
import SamplePage from 'pages/sample/SamplePage';
import GuideComponent from 'pages/sample/guide/GuideComponent';
import NotFoundPage from 'pages/common/NotFoundPage';

import LoginPage from 'pages/common/LoginPage';
import MenuManagementPage from 'pages/admin/MenuManagementPage';
import ApiUrlManagementPage from 'pages/admin/ApiUrlManagementPage';
import RoleDepartmentManagementPage from 'pages/admin/RoleDepartmentManagementPage';
import { MessageManagementPage } from 'pages/admin/MessageManagementPage';
import RoleManagementPage from 'pages/admin/RoleManagementPage';
import RoleEmployeeManagementPage from 'pages/admin/RoleEmployeeManagementPage';
import CodeManagementPage from 'pages/admin/CodeManagementPage';
import ProtectRoute from './ProtectRoute';
import ApprovalLineManagementPage from 'pages/admin/ApprovalLineManagementPage';
import ApprovalExcludeManagementPage from 'pages/admin/ApprovalExcludeManagementPage';
import { ApprovalTemplateManagementPage } from 'pages/admin/ApprovalTemplateManagementPage';
import NotificationManagementPage from 'pages/admin/NotificationManagementPage';
import BbsManagementPage from 'pages/admin/BbsManagementPage';
import BbsPostPage from 'pages/admin/BbsPostPage';
import { BbsEditPage } from 'pages/admin/BbsEditPage';
import NoticeManagementPage from 'pages/admin/noticemanagement/NoticeManagementPage';
import ApprovalDelegateManagementPage from 'pages/admin/ApprovalDelegateManagementPage';
import NoticeManagementDetailPage from 'pages/admin/noticemanagement/NoticeManagementDetailPage';
import IfLogManagementPage from 'pages/admin/IfLogManagementPage';
import EmailLogManagementPage from 'pages/admin/EmailLogManagementPage';
import MenuLogManagementPage from 'pages/admin/MenuLogManagementPage';
import LoginLogManagementPage from 'pages/admin/LoginLogManagementPage';
import DropzonSamplePage from 'pages/sample/DropzonSamplePage';
import CallTestPage from 'pages/sample/CallTestPage';
import GatingCheckSheetPage from 'pages/gtng/GatingCheckSheetPage';
import GtngVerMstPage from 'pages/gtng/GtngVerMstPage';

/* IP List */
import { StatusManagementPage } from 'pages/ip/maintenance/StatusManagementPage';
import EquipmentParameterPage from 'pages/ip/base/EquipmentParameterPage';
import EquipmentParameterRequestPage from 'pages/ip/base/EquipmentParameterRequestPage';
import BaseImformationPage from 'pages/ip/base/BaseImformationPage';
import GatingRegistPage from 'pages/gtng/GatingRegistPage';
import CheckResultRecordPage from 'pages/ip/maintenance/CheckResultRecordPage';
import CheckResultPage from 'pages/ip/maintenance/CheckResultPage';
import GatingResultReportPage from 'pages/gtng/GatingResultReportPage';
import GatingProgressManagementPage from 'pages/gtng/GatingProgressManagementPage';
import { GatingJudgementResultPage } from 'pages/gtng/GatingJudgementResultPage';

import ApproveManagementPage from 'pages/approves/ApproveManagementPage';
import ApproveRequestPage from 'pages/approves/ApproveRequestPage';
import ApproveRequestDetailPage from 'pages/approves/ApproveRequestDetailPage';
import GatingCheckResultPage from 'pages/gtng/GatingCheckResultPage';
import SensorListPage from 'pages/sensor/SensorListPage';
import SensorManagementPage from 'pages/sensor/base/SensorManagementPage';
import MpItemPage from 'pages/mp/MpItemPage';
import MpEquipmentClassificationPage from 'pages/mp/MpEquipmentClassificationPage';
import MpItemManagementPage from 'pages/mp/MpItemManagementPage';
import MpTargetManagementPage from 'pages/mp/MpTargetManagementPage';
import MpTrackingManagementPage from 'pages/mp/MpTrackingManagementPage';
import MpMcrcManagementPage from 'pages/mp/MpMcrcManagementPage';
import MpCodeManagementPage from 'pages/mp/MpCodeManagementPage';
import NewSensorSolutionReqStatusPage from 'pages/sensor/NewSensorSolutionReqStatusPage';
import NewSensorSolutionReqPage from 'pages/sensor/NewSensorSolutionReqPage';
import GuideWijmo from 'pages/sample/wijmo/GuideWijmo';
import DevelopMenualManagementPage from 'pages/admin/developmenualmanagement/DevelopMenualManagementPage';
import UploadTemplatePage from 'pages/admin/UploadTemplatePage';
import ExcpManagementPage from 'pages/partner/ExcpManagementPage';
import ExcpUserRegistPage from 'pages/partner/ExcpUserRegistPage';
import ExcpUserEditPage from 'pages/partner/ExcpUserEditPage';
import ExcpUserManagementPage from 'pages/partner/ExcpUserManagementPage';
import ExcpSecrPldgManagementPage from 'pages/partner/ExcpSecrPldgManagementPage';
import UtMatrixListPage from 'pages/ut/UtMatrixListPage';
import UtMatrixManagerPage from 'pages/ut/UtMatrixManagerPage';
import UtMatrixRegistPage from 'pages/ut/UtMatrixRegistPage';
import UtMatrixRequestPage from 'pages/ut/UtMatrixRequestPage';
import UtMatrixSummaryPage from 'pages/ut/UtMatrixSummaryPage';
import UtMatrixReviewPage from '../pages/ut/UtMatrixReviewPage';
import SetupDashboardPage from 'pages/pjm/SetupDashboardPage';
import FacilitySetupListPage from 'pages/pjm/FacilitySetupListPage';
import IdlAssetReviewManagerPage from 'pages/asst/IdlAssetReviewManagerPage';
import IdlAssetManagementPage from 'pages/asst/IdlAssetManagementPage';
import IdleAssetStatusPage from 'pages/asst/IdlAssetStatusPage';
import SetupMgrManagementPage from 'pages/pjm/SetupMgrManagementPage';
import UtMatrixStandardCodePage from 'pages/ut/UtMatrixStandardCodePage';
import UtMatrixLibraryPage from 'pages/ut/library/UtMatrixLibraryPage';
import UtMatrixHookupTagPage from 'pages/ut/UtMatrixHookupTagPage';
import MpFactoryPage from 'pages/mp/MpFactoryPage';
import MpItemTodoListPage from 'pages/mp/MpItemTodoListPage';
import MpProgressSummaryPage from '../pages/mp/MpProgressSummaryPage';
import MpProgressSummaryPlntPage from '../pages/mp/MpProgressSummaryPlntPage';
import UtMatrixEumTagIdPage from 'pages/ut/UtMatrixEumTagIdPage';
import SetupProjectPage from 'pages/setup/SetupProjectPage';
import SetupProjectRegistPage from 'pages/setup/regist/SetupProjectRegistPage';
import SetupEquipmentPage from 'pages/setup/SetupEquipmentPage';
import SetupEquipmentRegistPage from 'pages/setup/regist/SetupEquipmentRegistPage';
import SetupSchedulePage from 'pages/setup/SetupSchedulePage';
import SetupDailyReportPage from 'pages/setup/SetupDailyReportPage';
import SetupDailyReportRegistPage from 'pages/setup/daily/SetupDailyReportRegistPage';
import ProjectIssueSetupPage from 'pages/setup/issue/ProjectIssueSetupPage';
import ExcpRoleManagement from 'pages/partner/excp-role/ExcpRoleManagement';
import IdlAssetReviewResultDetailPage from 'pages/asst/IdlAssetReviewResultDetailPage';
import IdlAssetReviewListPage from 'pages/asst/IdlAssetReviewListPage';
import IdlAssetReviewReplyPage from 'pages/asst/IdlAssetReviewReplyPage';
import SetupMapChartPage from 'pages/setup/SetupMapChartPage';
import SetupMapChartRegistPage from 'pages/setup/regist/SetupMapChartRegistPage';
import SetupBoxManagementPage from 'pages/setup/excp/box/SetupBoxManagementPage';
import SetupItemManagementPage from 'pages/setup/excp/item/SetupItemManagementPage';
import SetupShipmentManagementPage from 'pages/setup/excp/shipment/SetupShipmentManagementPage';
import SetupPackingListManagementPage from 'pages/setup/excp/packing/SetupPackingListManagementPage';
import SetupHomePage from 'pages/setup/home/SetupHomePage';
import SetupProjectSummaryPage from 'pages/setup/home/summary/SetupProjectSummaryPage';
import SetupProjectStatusPage from 'pages/setup/home/SetupProjectStatusPage';
import SetupProjectSummaryDetailPage from 'pages/setup/home/summary/SetupProjectSummaryDetailPage';
import SetupBoxLocationManagementPage from 'pages/setup/mobile/SetupBoxLocationManagementPage';
import SetupMapZonManagementPage from 'pages/setup/mobile/SetupMapZonManagementPage';

import AuthRequestPage from '../pages/admin/rolemanagement/AuthRequestPage';
import AuthRequestListPage from '../pages/admin/rolemanagement/AuthRequestListPage';
import SetupProjectGraphPage from 'pages/setup/home/summary/SetupProjectGraphPage';
import SetupProjectManagerPage from 'pages/setup/SetupProjectManagerPage';
import SetupUnloadingDashboardPage from 'pages/setup/mobile/SetupUnloadingDashboardPage';
export const MenuUrl = {
  BbsManagementPage: '/system/admin/sample/bbs-sample',
  BbsPostPage: '/system/admin/sample/bbs-sample/:bbmNo',
  BbsEditPage: '/system/admin/sample/bbs-edit',
  BbsMenual: '/system/admin/sample/menual',
};

const RouterList: RouteObject[] = [
  { path: '/', element: <MainPage /> },
  // { path: '/sample', element: <SampleMainPage /> },
  { path: '/sample/sample', element: <SamplePage /> },
  { path: '/sample/dropzone', element: <DropzonSamplePage /> },
  { path: '/sample/call', element: <CallTestPage /> },
  { path: '/sample/guide/wijmo', element: <GuideWijmo /> },
  { path: '/sample/upload-templates', element: <CallTestPage /> },
  { path: '/sample/guide/component', element: <GuideComponent /> },
  { path: '/system/login', element: <LoginPage /> },
  { path: '/system/user-regist', element: <ExcpUserRegistPage /> },
  { path: '/system/user-edit', element: <ExcpUserEditPage /> },
  {
    element: <ProtectRoute />,
    children: [
      /* 접근제어가 필요한 화면 */
      /*{ path: '/sample', element: <SamplePage /> },*/
      { path: '/accessible', element: <SamplePage /> },
      { path: '/inaccessible', element: <SamplePage /> },
      /* TODO 테스트 용으로 머지시 삭제 */
    ],
  },
  { path: '/system/admin/role-menu/role-menu', element: <MenuManagementPage /> },
  { path: '/system/admin/message/message', element: <MessageManagementPage /> },
  { path: '/system/admin/api/api', element: <ApiUrlManagementPage /> },
  { path: '/system/admin/role/role', element: <RoleManagementPage /> },
  { path: '/system/admin/role-user/role-user', element: <RoleEmployeeManagementPage /> },
  {
    path: '/system/admin/role-department/role-department',
    element: <RoleDepartmentManagementPage />,
  },
  { path: '/system/admin/code/code', element: <CodeManagementPage /> },
  { path: '/system/admin/approval-line/approval-line', element: <ApprovalLineManagementPage /> },
  { path: '/system/admin/to-inform/to-inform', element: <NotificationManagementPage /> },
  {
    path: '/system/admin/approval-exclude/approval-exclude',
    element: <ApprovalExcludeManagementPage />,
  },
  {
    path: '/system/admin/approval-template/approval-template',
    element: <ApprovalTemplateManagementPage />,
  },
  {
    path: '/system/admin/approval-delegate/approval-delegate',
    element: <ApprovalDelegateManagementPage />,
  },
  {
    path: '/system/admin/upload-template',
    element: <UploadTemplatePage />,
  },
  {
    path: '/system/admin/excp/excp',
    element: <ExcpManagementPage />,
  },
  {
    path: '/system/admin/excp/excp-user',
    element: <ExcpUserManagementPage />,
  },
  {
    path: '/system/admin/excp/excp-secr-pldg',
    element: <ExcpSecrPldgManagementPage />,
  },
  {
    path: '/system/admin/excp/excp-role',
    element: <ExcpRoleManagement />,
  },
  { path: MenuUrl.BbsManagementPage, element: <BbsManagementPage /> },
  { path: '/system/admin/sample/bbs-sample/bbs-post', element: <BbsPostPage /> },
  { path: '/system/admin/sample/bbs-sample/bbs-edit', element: <BbsEditPage /> },
  { path: '/system/admin/sample/notice', element: <NoticeManagementPage /> },
  { path: '/system/admin/sample/notice-edit', element: <NoticeManagementDetailPage /> },
  { path: MenuUrl.BbsMenual, element: <DevelopMenualManagementPage /> },
  { path: '/system/admin/if-log/if-log', element: <IfLogManagementPage /> },
  { path: '/system/admin/email-log/email-log', element: <EmailLogManagementPage /> },
  { path: '/system/admin/menu-log/menu-log', element: <MenuLogManagementPage /> },
  { path: '/system/admin/login-log/login-log', element: <LoginLogManagementPage /> },
  { path: '/ip', element: null },
  { path: '/ip-regist', element: null },
  { path: '/ip/parameter', element: <BaseImformationPage /> },
  { path: '/ip/maintenance/StatusManagementPage', element: <StatusManagementPage /> },
  { path: '/ip/maintenance/check-result-record', element: <CheckResultRecordPage /> },
  { path: '/ip/maintenance/check-result', element: <CheckResultPage /> },
  { path: '/ip/equipment-parameter', element: <EquipmentParameterPage /> },
  { path: '/ip/equipment-parameter/request', element: <EquipmentParameterRequestPage /> },
  { path: '/gating/basic/check-sheet', element: <GatingCheckSheetPage /> },
  { path: '/gating/result/gating-check-result', element: <GatingCheckResultPage /> },

  { path: '/elm/gtng/gating-version-master', element: <GtngVerMstPage /> },
  { path: '/gating/basic/gating-regist', element: <GatingRegistPage /> },
  { path: '/gating/result/gating-result-report', element: <GatingResultReportPage /> },
  { path: '/gating/result/gating-judge-report', element: <GatingJudgementResultPage /> },
  { path: '/gating/result/gating-progress-management', element: <GatingProgressManagementPage /> },

  { path: '/approves/approve-management-page', element: <ApproveManagementPage /> },
  { path: '/approves/approve-request-page', element: <ApproveRequestPage /> },
  { path: '/approves/approve-request-detail', element: <ApproveRequestDetailPage /> },

  { path: '/sensor/sensorListPage', element: <SensorListPage /> },
  { path: '/sensor/sensor-management-page', element: <SensorManagementPage /> },
  { path: '/sensor/newSensorSolutionReqStatus', element: <NewSensorSolutionReqStatusPage /> },
  { path: '/sensor/newSensorSolutionReqPage', element: <NewSensorSolutionReqPage /> },

  { path: '/mp/item', element: <MpItemPage /> },
  { path: '/mp/equipment-clsf-page', element: <MpEquipmentClassificationPage /> },
  { path: '/mp/item-management', element: <MpItemManagementPage /> },
  { path: '/mp/item-management/new', element: <MpItemManagementPage /> },
  { path: '/mp/target', element: <MpTargetManagementPage /> },
  { path: '/mp/tracking-management', element: <MpTrackingManagementPage /> },
  { path: '/mp/dashboard/item-type-summary', element: <MpProgressSummaryPage /> },
  { path: '/mp/dashboard/item-type-summary-plnt', element: <MpProgressSummaryPlntPage /> },
  { path: '/mp/item-management/tpl', element: <MpTrackingManagementPage /> },
  { path: '/mp/mcrc-management', element: <MpMcrcManagementPage /> },
  { path: '/mp/code-management', element: <MpCodeManagementPage /> },
  { path: '/mp/factory', element: <MpFactoryPage /> },
  { path: '/mp/dashboard/todolist', element: <MpItemTodoListPage /> },

  { path: '/setup/home', element: <SetupHomePage /> },
  { path: '/setup/home/project-summary', element: <SetupProjectSummaryPage /> },
  { path: '/setup/home/project-summary-detail', element: <SetupProjectSummaryDetailPage /> },
  { path: '/setup/home/project-status', element: <SetupProjectStatusPage /> },
  { path: '/setup/home/project-graph', element: <SetupProjectGraphPage /> },
  { path: '/setup/project', element: <SetupProjectPage /> },
  { path: '/setup/project-detail', element: <SetupProjectRegistPage /> },
  { path: '/setup/project-detail/new', element: <SetupProjectRegistPage /> },
  { path: '/setup/equipment', element: <SetupEquipmentPage /> },
  { path: '/setup/equipment-detail', element: <SetupEquipmentRegistPage /> },
  { path: '/setup/map-chart', element: <SetupMapChartPage /> },
  { path: '/setup/map-chart-detail', element: <SetupMapChartRegistPage /> },
  { path: '/setup/project-manager', element: <SetupProjectManagerPage /> },
  { path: '/setup/schedule', element: <SetupSchedulePage /> },
  { path: '/setup/daily-report', element: <SetupDailyReportPage /> },
  { path: '/setup/daily-report/detail', element: <SetupDailyReportRegistPage /> },
  { path: '/setup/daily-report/new', element: <SetupDailyReportRegistPage /> },

  { path: '/setup/issue', element: <ProjectIssueSetupPage /> },

  { path: '/setup/excp/box', element: <SetupBoxManagementPage /> },
  { path: '/setup/excp/item', element: <SetupItemManagementPage /> },
  { path: '/setup/excp/shipment', element: <SetupShipmentManagementPage /> },
  { path: '/setup/excp/packing', element: <SetupPackingListManagementPage /> },

  { path: '/setup/mobile/unloading-map', element: <SetupBoxLocationManagementPage /> },
  { path: '/setup/mobile/map-zon', element: <SetupMapZonManagementPage /> },
  { path: '/setup/mobile/unloading-dashboard', element: <SetupUnloadingDashboardPage /> },

  { path: '/*', element: <NotFoundPage /> },

  { path: '/ut/ut-matrix-request', element: <UtMatrixRequestPage /> },
  { path: '/ut/regist-management/review', element: <UtMatrixReviewPage /> },
  { path: '/ut/regist-management/list', element: <UtMatrixListPage /> },
  { path: '/ut/ut-matrix-manager', element: <UtMatrixManagerPage /> },
  { path: '/ut/regist-management/regist', element: <UtMatrixRegistPage /> },
  { path: '/ut/ut-matrix-summary', element: <UtMatrixSummaryPage /> },
  { path: '/ut/info-management/library', element: <UtMatrixLibraryPage /> },
  { path: '/ut/info-management/standard-code', element: <UtMatrixStandardCodePage /> },
  { path: '/ut/regist-management/hookup', element: <UtMatrixHookupTagPage /> },
  { path: '/ut/eum-management/tagId-mapping', element: <UtMatrixEumTagIdPage /> },

  { path: '/setup/dashboard', element: <SetupDashboardPage /> },
  { path: '/setup/list', element: <FacilitySetupListPage /> },
  { path: '/setup/manager', element: <SetupMgrManagementPage /> },

  { path: '/asset/manager', element: <IdlAssetReviewManagerPage /> },
  { path: '/asset/management', element: <IdlAssetManagementPage /> },
  { path: '/asset/status', element: <IdleAssetStatusPage /> },
  { path: '/asset/review-result-detail', element: <IdlAssetReviewResultDetailPage /> },
  { path: '/asset/review-list', element: <IdlAssetReviewListPage /> },
  { path: '/asset/review-request-reply', element: <IdlAssetReviewReplyPage /> },
  { path: '/system/auth-request', element: <AuthRequestPage /> },
  { path: '/system/auth-request-list', element: <AuthRequestListPage /> },
];

export const getRoute = (path: string) => {
  return RouterList.filter((router) => router.path === path);
};

const Router = () => {
  // const { userId, teamYn, tldYn } = useSessionStore();
  // const appEnv = `${process.env.REACT_APP_NODE_ENV}`;
  return useRoutes(RouterList);
};

export default Router;
